import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'

import { getLanguages } from 'utils/languages'
import { EMAIL_FIELD, LANGUAGE_FIELD, NAME_FIELD, PHONE_FIELD } from './model'

export const CandidateForm = ({ control, formState, languages }) => (
  <Form>
    <Form.Field
      error={formState.errors[NAME_FIELD]?.message}
      label={t`Name`}
      field="input"
      name={NAME_FIELD}
      {...{ control }}
    />
    <Form.Field
      error={formState.errors[EMAIL_FIELD]?.message}
      label={t`Email`}
      field="input"
      name={EMAIL_FIELD}
      type="email"
      {...{ control }}
    />
    <Form.Field
      error={formState.errors[LANGUAGE_FIELD]?.message}
      label={t`Language`}
      field="combobox"
      name={LANGUAGE_FIELD}
      options={R.filter(
        language => R.includes(R.prop('value', language), languages),
        getLanguages(),
      )}
      isClearable
      {...{ control }}
    />
    <Form.Field
      error={
        formState.errors.root?.apiError?.message[PHONE_FIELD][0] ??
        formState.errors[PHONE_FIELD]?.message
      }
      label={t`Phone number`}
      field="input"
      hint={t`Use format as follows: +[country code] [number]`}
      name={PHONE_FIELD}
      type="tel"
      isOptional
      {...{ control }}
    />
  </Form>
)
